import http from './http';

export interface TemplateQueryParams {
  archived?: number;
  page?: number;
  limit?: number;
  [key: string]: any;
}

export const getTemplates = async (params?: TemplateQueryParams) => {
  return await http.get('/templates', params);
};

export const getTemplate = async (id: string) => {
  return await http.get(`/templates/${id}`);
};

export const updateTemplate = async(id: string, data: any) => {
  return await http.put(`/templates/${id}`, { data });
};

export const createTemplate = async(data: any) => {
  return await http.post(`/templates`, { data });
};
